import { ToastContainer, toast, ToastOptions } from "react-toastify";
import successIconSvg from "static/images/success-icon.svg";
import informationIconSvg from "static/images/info-icon.svg";
import attentionIconSvg from "static/images/attention-icon.svg";
import { isPrerendering } from "../../shared/utility/ApplicationUtility";

enum ToastVariant {
  "Success" = "Success",
  "Information" = "Information",
  "Attention" = "Attention",
}

interface ToastBodyProps {
  variant: ToastVariant;
  message: string;
}

const ToastBody = ({ variant, message }: ToastBodyProps) => {
  const getTitle = () => {
    const title =
      variant === ToastVariant.Attention
        ? "Attention!"
        : variant === ToastVariant.Information
        ? "Information"
        : "Success!";

    return title;
  };

  const getBorderColor = () => {
    const borderColor =
      variant === ToastVariant.Attention
        ? "border-promRed1"
        : variant === ToastVariant.Information
        ? "border-promBlue1"
        : "border-promDeepMint";

    return borderColor;
  };

  const getIcon = () => {
    const icon =
      variant === ToastVariant.Attention
        ? attentionIconSvg
        : variant === ToastVariant.Information
        ? informationIconSvg
        : successIconSvg;

    return (
      <div className="mx-6">
        <img src={icon} alt={`${variant}`} />
      </div>
    );
  };

  return (
    <div className="flex">
      <div className={`border-2.5 ${getBorderColor()} rounded`}></div>
      <div className="flex items-center">
        <div className="flex-shrink-0">{getIcon()}</div>
        <div className="text-black">
          <div className="font-bold">{getTitle()}</div>
          <div>{message}</div>
        </div>
      </div>
    </div>
  );
};

const toastOption: ToastOptions = {
  position: toast.POSITION.BOTTOM_RIGHT,
  className: "bg-white",
  hideProgressBar: true,
  bodyClassName: "p-0.5",
};

const toastMessage = (message: string, variant: ToastVariant) => {
  if (isPrerendering()) return;
  return toast(<ToastBody message={message} variant={variant} />, toastOption);
};

export const toastSuccess = (message: string) => {
  return toastMessage(message, ToastVariant.Success);
};

export const toastInformation = (message: string) => {
  return toastMessage(message, ToastVariant.Information);
};

export const toastError = (message: string) => {
  return toastMessage(message, ToastVariant.Attention);
};

export default function ToastNotificationContainer() {
  return (
    <ToastContainer
      position="bottom-left"
      autoClose={6000}
      className="w-365px"
    />
  );
}
